import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URLS from "../../urls";
//axios
import axios from "../../utils/axios";
//----------------------------------------------------

// GET =>  getWeeklyClassesForSection
export const getWeeklyClassesForSection = createAsyncThunk(
    "timeSlot/getWeeklyClassesForSection",
    async (id, thunkAPI) => {
        try {
            const response = await axios.get(`${URLS.getWeeklyClassesForSectionURL}/${id}`);
            return response;
        } catch (e) {
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

// POST =>  addTimeSlot
export const addTimeSlot = createAsyncThunk(
    "timeSlot/addTimeSlot",
    async (data, thunkAPI) => {
        try {
            const response = await axios.post(URLS.addTimeSlotURL, data);
            return response;
        } catch (e) {
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);


// DELETE =>  deleteTimeSlot
export const deleteTimeSlot = createAsyncThunk(
    "timeSlot/deleteTimeSlot",
    async (id, thunkAPI) => {
        try {
            const response = await axios.delete(`${URLS.deleteTimeSlotURL}/${id}`);
            return response;
        } catch (e) {
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
);